module.exports = __webpack_public_path__ + "static/manuPic-1165facf36f175685c2516be63be6e5a.jpg";